<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">

                <div class="modal-header">
                    <slot name="header">
                        <h3>Ticket erstellen</h3>
                        {{ event.name }} - {{ event.city }} - {{ new Date(event.date).toLocaleDateString("de-DE") }}
                        <div v-if="error" class="alert alert-danger mt-2" role="alert">
                            {{ error }}
                        </div>
                        <div v-if="info" class="alert alert-success mt-2" role="alert">
                            {{ info }}
                        </div>
                    </slot>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group row">
                                <div class="col-3">
                                    <label for="order">Bestellung</label>
                                    <input class="form-control mb-3" name="order" v-model="order" @keypress="isNumber($event)" :disabled="busy || ticketsCreated"/>
                                </div>
                                <div class="col-3">
                                    <label for="amount">Anzahl der Tickets</label>
                                    <input class="form-control mb-3" name="amount" v-model="amount" @keypress="isNumber($event)" :disabled="busy || ticketsCreated"/>
                                </div>
                                <div class="col-6">
                                    <label for="email">E-Mail (optional, für Versand)</label>
                                    <input class="form-control mb-3" type="email" name="email" v-model="email" placeholder="kunde@example.de" :disabled="busy"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-outline-danger" @click="$emit('TicketModalClosed')" :disabled="busy">Abbrechen</button>
                    <button class="btn btn-success" @click="addTicket('save')" :disabled="!valid || busy || ticketsCreated">Speichern</button>
                    <button class="btn btn-primary" @click="addTicket('pdf')" :disabled="!valid || busy || ticketsCreated">Speichern &amp; PDF</button>
                    <button class="btn btn-info text-white" @click="addTicket('email')" :disabled="!validEmail || busy">
                        <span v-if="busy && pendingAction === 'email'">Sende…</span>
                        <span v-else>{{ ticketsCreated ? 'E-Mail erneut senden' : 'Speichern &amp; E-Mail' }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: "TicketModal",
    props: {
        event: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            category: this.event.pricecategories[0].id,
            type: 2,
            order: null,
            error: "",
            info: "",
            amount: 1,
            email: "",
            busy: false,
            pendingAction: "",
            ticketsCreated: false,
        }
    },
    methods: {
        async addTicket (action) {
            this.error = "";
            this.info = "";
            this.busy = true;
            this.pendingAction = action;
            try {
                if (!this.ticketsCreated) {
                    await axios.post(process.env.VUE_APP_BACKEND + '/api/tickets', {
                        eventid: this.event.id,
                        pricecategoryid: this.category,
                        type: parseInt(this.type),
                        order: parseInt(this.order),
                        amount: parseInt(this.amount),
                    },{
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true,
                    }).then((response) => {
                        this.ticketsCreated = true;
                        this._createdResponse = response.data;
                    });
                }

                if (action === 'pdf') {
                    const data = this._createdResponse || [];
                    if (this.amount > 1 || !data[0]) {
                        window.open(process.env.VUE_APP_BACKEND + '/api/orders/' + this.event.id + '/' + this.order + '/print', '_self').focus()
                    } else {
                        window.open(process.env.VUE_APP_BACKEND + '/api/tickets/' + data[0].id + '/print', '_self').focus()
                    }
                    this.$emit('TicketModalSaved')
                    return
                }
                if (action === 'email') {
                    await axios.post(
                        process.env.VUE_APP_BACKEND + '/api/orders/' + this.event.id + '/' + this.order + '/send',
                        { email: this.email.trim() },
                        { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
                    )
                    this.$emit('TicketModalSaved')
                    return
                }
                this.$emit('TicketModalSaved')
            } catch (e) {
                const msg = (e.response && e.response.data && e.response.data.message)
                    ? e.response.data.message
                    : 'Fehler'
                this.error = msg
                if (this.ticketsCreated && action === 'email') {
                    this.info = 'Tickets sind gespeichert. Passe ggf. die E-Mail an und klicke erneut auf „Speichern & E-Mail“.'
                }
            } finally {
                this.busy = false
                this.pendingAction = ""
            }
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    },
    computed: {
        valid() {
            return !!(this.category && this.type == 2 && this.order);
        },
        validEmail() {
            if (!this.valid) return false;
            const e = (this.email || '').trim();
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
        }
    },
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 1000px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  font-family: Helvetica, Arial, sans-serif;
}

.modal-body {
  margin: 20px 0;
}

input[type=checkbox], input[type=radio] {
    width: 2.5rem;
    height: 2.5rem;
}
</style>
